export enum DisplayStatus {
    PENDING = 'PENDING',
    SENT = 'SENT',
    ACTIVE_VPN_ON = 'ACTIVE_VPN_ON',
    ACTIVE_VPN_OFF = 'ACTIVE_VPN_OFF',
    REVOKED = 'REVOKED',
}

export enum InviteStatus {
    PENDING = 'PENDING',
    SENT = 'SENT',
    ACCEPTED = 'ACCEPTED',
    REVOKED = 'REVOKED',
}

export enum DeviceStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
}

export enum VpnState {
    VPN_ACTIVE = 'VPN_ACTIVE',
    VPN_DISABLED = 'VPN_DISABLED',
}

export enum VpnDisconnectReason {
    USER_DISABLED = 'USER_DISABLED',
    VPN_FAILURE = 'VPN_FAILURE',
    CERT_REVOKED = 'CERT_REVOKED',
    CONNECTION_LOST = 'CONNECTION_LOST',
}

export interface VpnUsageSegment {
    startRatio: number;
    endRatio: number;
}

export interface VpnUsage {
    connectedSeconds: number;
    usagePercent: number;
    sessionCount: number;
    lastConnectedAt: string | null;
    windowStart: string;
    windowEnd: string;
    connectedSegments: VpnUsageSegment[];
}

export interface DeviceRow {
    inviteId: string;
    phoneNumber: string;
    userEmail: string;
    userName: string;
    inviteStatus: InviteStatus;
    displayStatus: DisplayStatus;
    deviceId: string | null;
    deviceStatus: DeviceStatus | null;
    vpnState: VpnState | null;
    vpnDisconnectReason?: VpnDisconnectReason | null;
    lastSeenAt: string | null;
    onboardedAt: string | null;
    invitedAt: string | null;
    createdBy: string;
    appVersion: string | null;
    vpnUsage: VpnUsage | null;
}

export interface InviteRequest {
    phoneNumber: string;
    userEmail?: string;
    userName?: string;
}

export interface InviteResponse {
    inviteId: string;
    phoneNumber: string;
    userEmail: string;
    userName: string;
    status: InviteStatus;
    createdAt: string;
    createdBy: string;
}

export interface SendInviteResponse {
    workflowId: string;
    results: Record<string, string>;
}
